import { render, staticRenderFns } from "./DocumentsLibratyItem.vue?vue&type=template&id=0043a566&scoped=true&"
import script from "./DocumentsLibratyItem.vue?vue&type=script&lang=js&"
export * from "./DocumentsLibratyItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsLibratyItem.vue?vue&type=style&index=0&id=0043a566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0043a566",
  null
  
)

export default component.exports